import { useLocalization } from '@im/react-localization';
import { getDayDifference } from '../../../mf-utils';
export function useFormatDate() {
  var _useLocalization = useLocalization(),
    formatDate = _useLocalization.formatDate,
    translate = _useLocalization.translate;
  return function (dateStr) {
    var date = new Date(dateStr);
    var diff = getDayDifference(date, new Date());
    if (diff === 0) {
      return translate('X4CNotifications.TodayAt', {
        time: formatDate(date, 'h:mm tt')
      });
    } else if (diff === 1) {
      return translate('X4CNotifications.YesterdayAt', {
        time: formatDate(date, 'h:mm tt')
      });
    } else if (diff > 1 && diff < 8) {
      return translate('X4CNotifications.DaysAgo', {
        days: diff.toString()
      });
    } else {
      return formatDate(date, 'ddd MMMM dd');
    }
  };
}